
import { bus } from '~/assets/js/eventBus'
import commonImg from '~/components/common/commonImg.vue'
import textTraderTitle from '~/components/textTrader/_title.vue'
export default {
  name: 'WzArticle',
  components: {
    'common-img': commonImg,
    'text-title': textTraderTitle
  },
  inject: ['info'],
  props: {
    result: {
      type: Object,
      default: () => {}
    },
    notitle: {
      type: String,
      default: ''
    }
  },
  data() {
    const _comShow = !(this.result && this.result.items && this.result.total && this.result.total > this.result.items.length)
    return {
      comShow: _comShow, // 是否已展示全部咨询
      total: this.result && this.result.total ? this.result.total : 0, // 文章总数
      pagesize: 6,
      pageindex: 1, // 当前分页
      articleData: this.result && this.result.items ? this.result.items : [],
      showArrow: false
    }
  },
  mounted() {
    bus.$on('TextTraderArrow', (sa) => {
      if (sa && (sa.pos == 'wenzhang' || sa.pos == 'all') && sa.show) {
        this.showArrow = true
      } else {
        this.showArrow = false
      }
    })
    console.log('文字版交易商资讯', this.result)
  },
  methods: {
    articleFn() {
      const that = this
      if (that.pageindex * that.pagesize >= that.result.total) {
        that.comShow = true
        return
      }

      that.$api.common
        .CV3(
          {
            code: that.info.traderCode,
            pageindex: that.pageindex + 1,
            pagesize: 3
          },
          {
            Routes: 'wikifxarticle$getthirdpartybyrelationid'
          }
        )
        .then((ret) => {
          that.pageindex++
          const _articles = ret && ret.wikifxarticle && ret.wikifxarticle.getthirdpartybyrelationid && ret.wikifxarticle.getthirdpartybyrelationid.data ? ret.wikifxarticle.getthirdpartybyrelationid.data : {} // 新闻列表
          if (_articles && _articles.items && _articles.items.length > 0) {
            _articles.items.forEach((item) => {
              that.articleData.push(item)
            })
            that.total = _articles.total
            if (that.articleData && that.articleData.length >= that.total) {
              that.comShow = true
            }
          }
        })
    },
    HideshowArrow() {
      this.showArrow = false
      bus.$emit('TextTraderArrow', {
        pos: this.postion,
        show: this.showArrow
      })
    }
  }
}
